import { AUTH_STORE_NAME, ORDER_STORE_NAME } from "../../../contants/stores";
import { store } from "../../../redux";
import { applyPromoCode, callOmsOrderCartUpdate, callOrderETAService, fetchActiveOrders, save, saveCart, saveAddressInCourier, callOmsOrderComplete, callUnAssignAPI, changeOrderStatus, changeOrderType, changePaymentInCourier, savePaymentDetails, sendNotifications, getBuddyDetails, callSearch, getOrdersByFleetId, callETAUpdate, serachPaciFromLoc, generateToken, updateToken, uploadFileToStorage, checkDelayNotificationValidity, reschedule, editStopInCourier } from "../services/order.services";
import { actions as orderActions, initialState } from "../stores/order.store";
import { TOrderItem } from "../types/order.item";
import { addAddress, updateAddressList, validateAddress } from "../../customer/services/customer.services";
import { orderSearch } from "../services/order.services";
import { assignValueToObject, Order } from "../types/order.data";
import { OrderInfo } from "../types/order.orderInfo";
import { triggerPubSubEventCloudFunction } from "../../../utils/pubsub";
import firebase from "firebase";
import { timelineNames, timelineTypes } from "../../../contants/timelineEvents";
import { searchCustomerByPhone, addWalletEntry } from "../../customer/actions/customer.actions";
import { createPromoCode } from "../../promocode/actions/propmoCode.actions";
import { fetchOrderTransfer } from "../../agent/services/agent.service";
import { Agent } from "../../agent/types/agent.data";

export const getOrdersData = () => {
  try {
    const agent = store.getState()[AUTH_STORE_NAME].loggedInAgent;
    const isAgent = !agent.isAdmin && !agent.isSuperAdmin;
    return fetchActiveOrders(agent.id, isAgent, {
      listeners: {
        onGetAll: (res: any) => {
          if (res.errors) {
            throw new Error("Could not fetch orders");
          }
          // if(res?.orders?.length) updateSelectedOrder(res?.orders[0]?.id ?? '');
          store.dispatch(orderActions.setOrders(res.orders));
        },
        onAdd: () => {},
        onUpdate: (res: any) => {
          store.dispatch(orderActions.updateOrder({ ...res }));
        },
      },
    });
  } catch (error) {
    console.log("get-orders", error);
  }
}

export const getBuddyActiveOrders = async (fleetId: number) => {
  const orders = await getOrdersByFleetId(fleetId);
  return orders?.map((doc: any) => { 
    return { orderNo: doc.data().orderNo, subStatus: doc.data().subStatus, id: doc.id, tripInfo: doc.data().tripInfo } 
  });
}

export const updateSelectedOrder = (id: string) => {
  store.dispatch(orderActions.setSelectedOrderId<any>(id));
}

export const updateSelectedSubStatuses = (subStatuses: any) => {
  store.dispatch(orderActions.setSelectedSubStatuses(subStatuses));
}

export const updateSelectedPrimaryStatus = (primary: { show: boolean, status: string }) => {
  store.dispatch(orderActions.setSelectedPrimaryStatus(primary));
}

export const updateOrderFilters = (filters: any []) => {
  store.dispatch(orderActions.setAppliedFilters(filters));
}

export const clearFilters = () => {
  store.dispatch(orderActions.setAppliedFilters(initialState.filters));
}

export const changeActiveMode = (activeMode: string) => {
  store.dispatch(orderActions.setActiveMode(activeMode));
}

export const updateOrderPriorityActions = async (orderId: string, orderNo: string, priorityStatus: any) => {
  await save(orderId, { 
    "priorityStatus": priorityStatus, 
  });
}

export const updateOrderInfoOnAddressUpdate = async (address: any, type: string, orderId: string, orderNo: string) => {
  let order = store.getState()[ORDER_STORE_NAME].orders.find((order: Order) => order.id === orderId);
  const agent = store.getState()[AUTH_STORE_NAME].loggedInAgent;

  if(!order) order = store.getState()[ORDER_STORE_NAME].searchOrder;
  
  order = type === "pickup" ? {...order, pickupAddress: address} : {...order, deliveryAddress: address};
  const items = order?.orderInfo?.items.map((item: any) => {
    return {
      ...item,
      total: +(item.quantity * item.price).toFixed(2),
    };
  });
  const itemCount = items.filter((item : any) => !item.isCancelled).length;
  const itemTotal = items.filter((item : any) => !item.isCancelled).reduce((acc: any, item: any) => acc + (item.price * item.quantity), 0);

  const ETAData = await calculateOrderETA(order, itemCount, itemTotal);
  const discountData = await calculateDiscount(order?.orderInfo, ETAData);
  await save(orderId, { 
    "orderInfo.discount": discountData, 
    "orderInfo.deliveryFee": ETAData.deliveryFee,
    "orderInfo.serviceFee": ETAData.serviceFee,
    "deliveryDistance": ETAData.distance,
    "etaSeconds": ETAData.etaSeconds,
    "etas.etPickupToDelivery": ETAData.etaSeconds,
  });
  callOmsOrderCartUpdate(orderNo, agent?.name);
  callETAUpdate(orderId, orderNo)
} 

export const saveAddress = async (orderId: string, orderNo: string, type: string, address: any, fleetId: any, orderType: string, userId: string, orderValidation: any, saveAddressId: string, activeMode: string) => {
  const agent = store.getState()[AUTH_STORE_NAME].loggedInAgent;
  if(userId && orderType !== 'COURIER' && activeMode === 'add') {//Update saved address
    const id = await addAddress(userId, address);
    updateAddressList(userId, {id: id})
    address = {...address, id: id}
  }

  save(orderId, type === "pickup" ? {pickupAddress: address, ...(orderType !== 'COURIER' ? { orderValidation: orderValidation } : {} )} : {deliveryAddress: address, ...(orderType !== 'COURIER' ? { orderValidation: orderValidation } : {} )});

  const comment = `${type === "pickup" ? "Pickup ": "Delivery "}addredd has been updated.`
  addTimeLineEvent(agent, orderNo, orderId, timelineTypes.ADDRESS, timelineNames.ADDRESS_UPDATE, comment);

  if(fleetId) { //notfy the buddy
    const msgTitle = `Update - ${orderNo}`;
    const msgBody = `${type === "pickup" ? "Pickup" : "Delivery"} address has been updated`;
    buddiesNotifications(msgTitle, msgBody, fleetId);
  }
  if(userId && orderType !== 'COURIER' && activeMode !== 'add') {//Update saved address
    updateAddressList(userId, address);
  }
}

export const saveMultiStopAddresses = async (orderId: string, orderNo: string, deliveryStops: any[], fleetId: any, orderType: string, orderValidation: any, changedStopIndices?: number[], dropoffStatuses?: any[]) => {
  const agent = store.getState()[AUTH_STORE_NAME].loggedInAgent;
  
  // Use deliveryStops and orderValidation as-is
  const cleanedDeliveryStops = deliveryStops;
  const cleanedOrderValidation = orderType !== 'COURIER' ? orderValidation : undefined;
  const cleanedDropoffStatuses = dropoffStatuses;
  
  // Get order first to access dropoffStatuses and other data
  const order = store.getState()[ORDER_STORE_NAME].orders.find((order: Order) => order.id === orderId) ||
                store.getState()[ORDER_STORE_NAME].searchOrder;
  
  if (!order) {
    throw new Error("Order not found");
  }
  
  const deliveryNo = order?.deliveryInfo?.deliveryNo || orderNo;
  const orderDropoffStatuses = cleanedDropoffStatuses || order?.deliveryInfo?.dropoff_statuses || [];
  
  // STEP 1: Call edit API for changed stops (if they have job_id)
  if (changedStopIndices && changedStopIndices.length > 0) {
    const apiResults: Array<{ index: number; success: boolean; error?: any }> = [];
    
    for (const index of changedStopIndices) {
      const stop = cleanedDeliveryStops[index];
      if (!stop) {
        continue;
      }
      
      // Try to find job_id from multiple sources
      let jobId = stop.job_id || stop.jobId;
      
      // If not found in stop, try dropoffStatuses
      if (!jobId && orderDropoffStatuses[index]) {
        jobId = orderDropoffStatuses[index].job_id || orderDropoffStatuses[index].jobId;
      }
      
      // If still not found, try matching by location
      if (!jobId && orderDropoffStatuses.length > 0) {
        const stopLat = stop.location?._lat || stop.location?.latitude;
        const stopLong = stop.location?._long || stop.location?.longitude;
        const matchedStatus = orderDropoffStatuses.find((status: any) => {
          const statusLat = status.latitude || status.location?._lat || status.location?.latitude;
          const statusLong = status.longitude || status.location?._long || status.location?.longitude;
          return statusLat === stopLat && statusLong === stopLong;
        });
        if (matchedStatus) {
          jobId = matchedStatus.job_id || matchedStatus.jobId;
        }
      }
      
      // Skip if no job_id found (stop might not be assigned yet)
      if (!jobId) {
        continue;
      }
      
      // Extract location coordinates
      const latitude = stop.location?._lat || stop.location?.latitude || stop.latitude || '';
      const longitude = stop.location?._long || stop.location?.longitude || stop.longitude || '';
      
      // Prepare stop data for API
      const stopData = {
        customer_name: stop.contactName || stop.name || '',
        mobile_number: stop.contactPhone || stop.mobile_number || '',
        address: stop.addressStr || stop.address || '',
        street: stop.street || '',
        area: stop.area || '',
        block: stop.block || '',
        latitude: latitude,
        longitude: longitude
      };
      
      // Call API and wait for success
      try {
        await editStopInCourier(deliveryNo, jobId, stopData);
        apiResults.push({ index, success: true });
      } catch (error) {
        console.error(`API call failed for stop ${index}:`, error);
        apiResults.push({ index, success: false, error });
        // Continue with other stops, but we'll know which ones failed
      }
    }
  }
  
  // STEP 2: Update Firebase with new deliveryStops
  const updateData: any = {
    deliveryStops: cleanedDeliveryStops,
    ...(orderType !== 'COURIER' && cleanedOrderValidation ? { orderValidation: cleanedOrderValidation } : {})
  };
  
  // If dropoffStatuses is provided, update deliveryInfo.dropoff_statuses
  if (cleanedDropoffStatuses !== undefined) {
    updateData['deliveryInfo.dropoff_statuses'] = cleanedDropoffStatuses;
  }
  
  // Save to Firebase
  await save(orderId, updateData);
  
  // Update Redux store with new deliveryStops so UI reflects changes immediately
  const updatedOrderForRedux = {
    ...order,
    deliveryStops: cleanedDeliveryStops,
    isMultiStopOrder: cleanedDeliveryStops.length > 1,
    ...(cleanedDropoffStatuses !== undefined && order.deliveryInfo ? {
      deliveryInfo: {
        ...order.deliveryInfo,
        dropoff_statuses: cleanedDropoffStatuses
      }
    } : {}),
    ...(orderType !== 'COURIER' && cleanedOrderValidation ? { orderValidation: cleanedOrderValidation } : {})
  };
  
  store.dispatch(orderActions.updateOrder({
    id: orderId,
    data: updatedOrderForRedux
  }));
  
  // STEP 3: Recalculate order amounts if stops were edited
  if (changedStopIndices && changedStopIndices.length > 0) {
    try {
      // Use the order we already fetched
      if (order) {
        // Get original stops before edit
        const originalStops = order.deliveryStops || [];
        
        // Get items for calculation
        const items = order.orderInfo?.items || [];
        const itemCount = items.filter((item: any) => !item.isCancelled).length || 0;
        const itemTotal = order.orderInfo?.itemTotal || 
          items.filter((item: any) => !item.isCancelled)
            .reduce((acc: number, item: any) => acc + ((item.quantity || 0) * (item.price || 0)), 0);
        
        // Get storeId for ETA calculation
        const storeId = order.orderType === "BUY"
          ? order.pickupAddress?.placeId != null
            ? order.pickupAddress.placeId
            : null
          : order.orderType === "SELLER"
            ? order.sellerInfo?.sellerId
            : null;
        
        // Get original amounts
        const oldDeliveryFee = order.orderInfo?.deliveryFee || 0;
        const oldServiceFee = order.orderInfo?.serviceFee || 0;
        const oldItemTotal = order.orderInfo?.itemTotal || itemTotal;
        const oldBuddyTip = order.orderInfo?.buddyTip || 0;
        const oldDiscount = order.orderInfo?.discount || 0;
        const oldOnlinePaid = order.orderInfo?.onlinePaid || 0;
        const oldWalletPaid = order.orderInfo?.walletPaid || 0;
        
        // Calculate segment amounts for each edited stop
        let totalOldSegmentDeliveryFee = 0;
        let totalOldSegmentServiceFee = 0;
        let totalNewSegmentDeliveryFee = 0;
        let totalNewSegmentServiceFee = 0;
        
        for (const stopIndex of changedStopIndices) {
          const oldStop = originalStops[stopIndex];
          if (!oldStop || !oldStop.location) {
            continue;
          }
          const newStop = cleanedDeliveryStops[stopIndex];
          if (!newStop || !newStop.location) {
            continue;
          }
          
          // Get old stop location
          const oldStopLocation = {
            latitude: oldStop.location._lat || oldStop.location.latitude || 0,
            longitude: oldStop.location._long || oldStop.location.longitude || 0
          };
          
          // Get new stop location
          const newStopLocation = {
            latitude: newStop.location._lat || newStop.location.latitude || 0,
            longitude: newStop.location._long || newStop.location.longitude || 0
          };
          
          if (oldStopLocation.latitude === 0 || oldStopLocation.longitude === 0 ||
              newStopLocation.latitude === 0 || newStopLocation.longitude === 0) {
            continue;
          }
          // Determine origin for OLD segment: pickup for first stop, original previous stop for others
          let oldOriginLocation;
          if (stopIndex === 0) {
            oldOriginLocation = {
              latitude: order.pickupAddress?.location?._lat || 0,
              longitude: order.pickupAddress?.location?._long || 0
            };
          } else {
            const oldPreviousStop = originalStops[stopIndex - 1];
            if (!oldPreviousStop || !oldPreviousStop.location) {
              continue;
            }
            const prevLat = oldPreviousStop.location._lat || oldPreviousStop.location.latitude;
            const prevLong = oldPreviousStop.location._long || oldPreviousStop.location.longitude;
            if (prevLat === undefined || prevLat === null || prevLong === undefined || prevLong === null) {
              continue;
            }
            oldOriginLocation = {
              latitude: prevLat,
              longitude: prevLong
            };
          }
          
          // Determine origin for NEW segment: pickup for first stop, new previous stop for others
          let newOriginLocation;
          if (stopIndex === 0) {
            newOriginLocation = {
              latitude: order.pickupAddress?.location?._lat || 0,
              longitude: order.pickupAddress?.location?._long || 0
            };
          } else {
            const newPreviousStop = cleanedDeliveryStops[stopIndex - 1];
            if (!newPreviousStop || !newPreviousStop.location) {
              continue;
            }
            const prevLat = newPreviousStop.location._lat || newPreviousStop.location.latitude;
            const prevLong = newPreviousStop.location._long || newPreviousStop.location.longitude;
            if (prevLat === undefined || prevLat === null || prevLong === undefined || prevLong === null) {
              continue;
            }
            newOriginLocation = {
              latitude: prevLat,
              longitude: prevLong
            };
          }
          
          if (!oldOriginLocation || oldOriginLocation.latitude === 0 || oldOriginLocation.longitude === 0 ||
            !newOriginLocation || newOriginLocation.latitude === 0 || newOriginLocation.longitude === 0) {
              continue;
            }
            
          const oldSegmentETAData = await callOrderETAService({
            pickup: oldOriginLocation,
            delivery: oldStopLocation,
            orderType: order.orderType,
            storeId: storeId,
            itemCount: itemCount,
            itemTotal: itemTotal
          });
          
          const newSegmentETAData = await callOrderETAService({
            pickup: newOriginLocation,
            delivery: newStopLocation,
            orderType: order.orderType,
            storeId: storeId,
            itemCount: itemCount,
            itemTotal: itemTotal
          });
          
          if (!oldSegmentETAData || !newSegmentETAData) {
            continue;
          }
          
          const oldSegmentDeliveryFee = oldSegmentETAData.deliveryFee || 0;
          const oldSegmentServiceFee = oldSegmentETAData.serviceFee || 0;
          const newSegmentDeliveryFee = newSegmentETAData.deliveryFee || 0;
          const newSegmentServiceFee = newSegmentETAData.serviceFee || 0;
          
          totalOldSegmentDeliveryFee += oldSegmentDeliveryFee;
          totalOldSegmentServiceFee += oldSegmentServiceFee;
          totalNewSegmentDeliveryFee += newSegmentDeliveryFee;
          totalNewSegmentServiceFee += newSegmentServiceFee;
        }
        
        if (totalOldSegmentDeliveryFee !== 0 || totalNewSegmentDeliveryFee !== 0 ||
          totalOldSegmentServiceFee !== 0 || totalNewSegmentServiceFee !== 0) {
            // Calculate new totals: subtract old segments, add new segments
            // This preserves amounts from other stops and only adjusts the edited stop
            const deliveryFeeDifference = totalOldSegmentDeliveryFee - totalNewSegmentDeliveryFee;
            const serviceFeeDifference = totalOldSegmentServiceFee - totalNewSegmentServiceFee;
            
            // Adjust the original amounts: subtract old segment amounts, add new segment amounts
            // This way we preserve amounts from all other stops
            const newDeliveryFee = Math.max(0, oldDeliveryFee - totalOldSegmentDeliveryFee + totalNewSegmentDeliveryFee);
            const newServiceFee = Math.max(0, oldServiceFee - totalOldSegmentServiceFee + totalNewSegmentServiceFee);
            
            // Recalculate discount based on new delivery fee (if needed)
            // For now, keep old discount since it's usually based on total amount
            const newDiscount = oldDiscount;
            
            // Recalculate total amount using the adjusted fees
            // This preserves itemTotal, buddyTip, and discount, only adjusting deliveryFee and serviceFee
            const newTotalAmount = 
            oldItemTotal + 
            newServiceFee + 
            newDeliveryFee +
            oldBuddyTip - 
            newDiscount;
            
            const newCashToCollect = Math.round((newTotalAmount - oldOnlinePaid - oldWalletPaid) * 100) / 100;
            const amountDifference = deliveryFeeDifference + serviceFeeDifference;
            
            // Update amounts in Firebase
            const amountUpdateData: any = {};
            if (newDeliveryFee !== undefined && newDeliveryFee !== null && newDeliveryFee >= 0) {
              amountUpdateData["orderInfo.deliveryFee"] = newDeliveryFee;
            }
            if (newServiceFee !== undefined && newServiceFee !== null && newServiceFee >= 0) {
              amountUpdateData["orderInfo.serviceFee"] = newServiceFee;
            }
            if (newDiscount !== undefined && newDiscount !== null) {
            amountUpdateData["orderInfo.discount"] = newDiscount;
          }
          if (newTotalAmount !== undefined && newTotalAmount !== null && !isNaN(newTotalAmount) && newTotalAmount >= 0) {
            amountUpdateData["orderInfo.totalAmount"] = newTotalAmount;
          }
          
          await savePaymentDetails(orderId, order.orderInfo?.paymentType || 'CASH', newCashToCollect);
          
          if (Object.keys(amountUpdateData).length > 0) {
            await save(orderId, amountUpdateData);
          }
          
          // Get the latest order from Redux (which should have the updated deliveryStops from our previous update)
          const latestOrderFromRedux = store.getState()[ORDER_STORE_NAME].orders.find((order: Order) => order.id === orderId) ||
                                       store.getState()[ORDER_STORE_NAME].searchOrder;
          
          // Update Redux store with new amounts AND preserve the updated deliveryStops
          const updatedOrderWithAmounts = {
            ...(latestOrderFromRedux || updatedOrderForRedux), // Use latest from Redux if available, otherwise use our updated order
            deliveryStops: cleanedDeliveryStops, // Explicitly preserve the new deliveryStops
            isMultiStopOrder: cleanedDeliveryStops.length > 1,
            orderInfo: {
              ...(latestOrderFromRedux || updatedOrderForRedux)?.orderInfo,
              deliveryFee: newDeliveryFee,
              serviceFee: newServiceFee,
              totalAmount: newTotalAmount,
              cashToCollect: newCashToCollect,
              discount: newDiscount
            },
            ...(cleanedDropoffStatuses !== undefined && (latestOrderFromRedux || updatedOrderForRedux)?.deliveryInfo ? {
              deliveryInfo: {
                ...(latestOrderFromRedux || updatedOrderForRedux).deliveryInfo,
                dropoff_statuses: cleanedDropoffStatuses
              }
            } : {}),
            ...(orderType !== 'COURIER' && cleanedOrderValidation ? { orderValidation: cleanedOrderValidation } : {})
          };
          store.dispatch(orderActions.updateOrder({
            id: orderId,
            data: updatedOrderWithAmounts
          }));
          
          if (amountDifference > 0 && (oldOnlinePaid > 0 || oldWalletPaid > 0)) {     
            const customerId = order.user?.id;
            if (customerId) {
              await addWalletEntry(
                customerId,
                amountDifference,
                `Refund for edited stop in order ${orderNo}`
              );
            }
          }
        }
      }
    } catch (error) {
      console.error("Error recalculating amounts:", error);
    }
  }

  // Create comment based on which stops were changed
  let comment: string;
  if (changedStopIndices && changedStopIndices.length > 0) {
    const stopNumbers = changedStopIndices.map(i => `Stop ${i + 1}`).join(', ');
    comment = `Delivery address updated for ${stopNumbers}.`;
  } else {
    comment = `Multi-stop delivery addresses have been updated (${deliveryStops.length} stops).`;
  }
  
  addTimeLineEvent(agent, orderNo, orderId, timelineTypes.ADDRESS, timelineNames.ADDRESS_UPDATE, comment);

  if(fleetId) {
    const msgTitle = `Update - ${orderNo}`;
    const msgBody = changedStopIndices && changedStopIndices.length > 0 
      ? `Delivery address updated for ${changedStopIndices.map(i => `Stop ${i + 1}`).join(', ')}`
      : `Delivery stops have been updated (${deliveryStops.length} stops)`;
    buddiesNotifications(msgTitle, msgBody, fleetId);
  }
}

export const updateAddressCourier = async(address: any, mode: string, type: string, orderNo: string, orderType: string, orderId: string) => {
  const fleetConfig = store.getState()[ORDER_STORE_NAME].fleetConfig;
  const payload = mode === 'map' ? {
    "address": address.addressStr,
    "latitude": address.location.latitude ,
    "longitude": address.location.longitude,
    'mobile_number': address.contactPhone,
    'customer_name': `${orderType !== "COURIER" ? (address.name ? address.name + "| ": " " + address.contactName) : address.contactName}`,
    "floor": address.floorNumber,
    "room_number": address.roomNumber,
    "landmark": address.landmark,
  } : {
    "address": address.addressStr,
    "addressName": address.name.trim(),
    "floor": address.floorNumber,
    "room_number": address.roomNumber,
    "area": address.area,
    "area_id": address.area_id,
    "areaDoc_id": address.areaDoc_id || null,
    "block": address.block,
    "block_id": address.block_id,
    "street": address.street,
    "street_id": address.street_id,
    "latitude": address.location.latitude ,
    "longitude": address.location.longitude,
    "landmark": address.landmark,
    'customer_name': `${orderType !== "COURIER" ? (address.name ? address.name + "| " : " " + address.contactName) : address.contactName}`,
    'mobile_number': address.contactPhone,
  };
  saveAddressInCourier(payload, orderNo, type, address, orderId, fleetConfig);
  
}

export const paciSearch = async(lat:number, lng:number) =>{
  try {
    const businessConfig = store.getState()[ORDER_STORE_NAME].businessConfig;
    let res: any = await serachPaciFromLoc(lat, lng, businessConfig.paciArcgis);
    if (res.error) {
      //Generate token
      const token = await generateToken(businessConfig?.paciArcgis);
      updateToken(token);
      const config = {
        ...businessConfig,
        paciArcgis: {
          ...businessConfig.paciArcgis,
          token: token,
        },
      };
      store.dispatch(orderActions.setBusinessConfig(config));
      res = await serachPaciFromLoc(lat, lng, config.paciArcgis);
    }
    let results = res.results;
    const locDetials = {
      areaId: results[1].attributes.Nhood_No,
      areaName: results[1].attributes.neighborhoodenglish,
      blockName: results[0].attributes.blockenglish,
    }
    return locDetials;
  } catch (error) {
    console.log("Error-paciSearch: ", error)
  }
}


let unsubRef: Promise<(() => void) | undefined> | undefined;

export const close = () => {
  store.dispatch(orderActions.setSearchOrder({}));
  store.dispatch(orderActions.setSearchQuery(""));
  if (unsubRef) {
    stopListener(unsubRef);
  }
}

const stopListener = (unsubRef: any) => {
  // unsubRef();
  return () => {
    if (unsubRef) unsubRef();
  }
};

export const search = async (opt: string, value: string) => {
  switch (opt) {
    case "CUSTOMER":
      return searchCustomerByPhone(value);
    case "ORDER":
      store.dispatch(orderActions.setSearchQuery(value));
      let order;
      orderSearch(value, {
        listeners: {
          onGetAll: (res: any) => {
            if (res.errors) {
              throw new Error("Could not fetch orders");
            }
            // if(res?.orders?.length) updateSelectedOrder(res?.orders[0]?.id ?? '');
            order = res.orders[0];
            store.dispatch(orderActions.setSearchOrder(res.orders[0]));
          },
          onUpdate: (res: any) => {
            store.dispatch(orderActions.setSearchOrder({ ...res }));
            order = { ...res };
          },
        },
      }); 
      store.dispatch(orderActions.setSearchOrder(order))
      return order;
    default:
      break;
  }
};

export const searchForCallSource = async (phone: string) => {

  try {
    //checking if the incoming call is from customer
    //then showing the latest order in the modal
    let query = await callSearch("user.phone", phone);
    
    //if call is not from customer then checking for buddy phone number
    if (query?.empty) {
      query = await callSearch("deliveryInfo.buddyPhone", phone);
    }

    //if call is not from customer, buddy and delivery address
    //then checking for pickup address contact number
    if (query?.empty) {
      query = await callSearch("deliveryAddress.contactPhone", phone);
    }
    if (query?.empty) {
      query = await callSearch("pickupAddress.contactPhone", phone);
    }


    if(query?.empty) {
      return;
    }

    store.dispatch(orderActions.setSearchOrder(assignValueToObject(query?.docs[0])));

  } catch (error) {
    console.log("Error searching for call source", error)
  } 
}

export const calculateCartUpdates = async(orderId:string, items: TOrderItem[]) =>{
  let order = store.getState()[ORDER_STORE_NAME].orders.find((order: Order) => order.id === orderId);
  if(!order) order = store.getState()[ORDER_STORE_NAME].searchOrder;
  const orderInfo = order?.orderInfo;
  items = items.map((item: any) => {
    return {
      ...item,
      total: +(item.quantity * item.price).toFixed(2),
    };
  });
  const itemCount = items.filter((item : any) => !item.isCancelled).length;
  const itemTotal = items.filter((item : any) => !item.isCancelled).reduce((acc, item: any) => acc + item.total, 0);

  const ETAData = await calculateOrderETA(order, itemCount, itemTotal);
  const discountData = await calculateDiscount(orderInfo, ETAData);
  const totalAmount =
    itemTotal + ETAData.serviceFee + 
    ETAData.deliveryFee +
    (orderInfo.buddyTip || 0) - 
    (discountData || 0);
  const cashToCollect = Math.round((totalAmount - orderInfo.onlinePaid - orderInfo.walletPaid) * 100) / 100;
  return {
    orderNo :order.orderNo,
    items: items,
    itemCount: itemCount,
    itemTotal: itemTotal,
    ETAData: ETAData,
    discountData: discountData,
    cashToCollect: cashToCollect, 
  }
}

export const updateCart = async (orderId:string, orderNo: string, items: TOrderItem[], udatedDate: any, fleetId: any, orderValidation: any) => {
  const agent = store.getState()[AUTH_STORE_NAME].loggedInAgent;
  const itemCount = udatedDate.itemCount;
  const itemTotal = udatedDate.itemTotal;

  const ETAData = udatedDate.ETAData;
  const discountData = udatedDate.discountData;

  const comment = "Cart has been updated."


  
  await saveCart(orderId, items, ETAData, discountData, itemCount, itemTotal, orderValidation);
  callOmsOrderCartUpdate(udatedDate.orderNo, agent.name);
  callETAUpdate(orderId, orderNo);
  addTimeLineEvent(agent, orderNo, orderId, timelineTypes.CART, timelineNames.CART_UPDATE, comment);

  if(fleetId) {
    const msgTitle = `Update - ${orderNo}`;
    const msgBody = "Cart has been updated";
    
    buddiesNotifications(msgTitle, msgBody, fleetId);
  }
  
}

const calculateOrderETA = async (order: Order, itemCount: number, itemTotal: number ) => {
  
  const storeId = order.orderType === "BUY"
          ? order.pickupAddress.placeId != null
            ? order.pickupAddress.placeId
            : null
          : order.orderType === "SELLER"
            ? order.sellerInfo.sellerId
            : null;
  
  // For multi-stop orders, use the last delivery stop; otherwise use deliveryAddress
  let deliveryLocation;
  if (order.isMultiStopOrder && order.deliveryStops && order.deliveryStops.length > 0) {
    const lastStop = order.deliveryStops[order.deliveryStops.length - 1];
    deliveryLocation = {
      latitude: lastStop.location?._lat || 0,
      longitude: lastStop.location?._long || 0
    };
  } else {
    deliveryLocation = {
      latitude: order.deliveryAddress?.location?._lat || 0,
      longitude: order.deliveryAddress?.location?._long || 0
    };
  }
  
  const props = {
    pickup: { 
      latitude: order.pickupAddress.location._lat,
      longitude: order.pickupAddress.location._long
    },
    delivery: deliveryLocation,
    orderType: order.orderType,
    storeId: storeId,
    itemCount: itemCount,
    itemTotal: itemTotal
  };

  return await callOrderETAService(props);
  
}

const calculateDiscount = async(orderInfo: OrderInfo, ETAData: any) => {
  let discount = 0 ;
  if(orderInfo?.promoCode) {
    const body = {
      "title": orderInfo.promoCode.title,
      "serviceFee": ETAData.serviceFee,
      "deliveryFee": ETAData.deliveryFee,
      "itemTotal": orderInfo.itemTotal,
      "appliedDiscount": orderInfo.promoCode.discountValue
    }
    const res = await applyPromoCode(body);
    discount = res.discount;
  }
  return +discount.toFixed(2);
}

export const unssignBuddy = async (orderNo: string, deliveryNo: string, orderId: string) => {
  try {
    const agent = store.getState()[AUTH_STORE_NAME].loggedInAgent;
    const fleetConfig = store.getState()[ORDER_STORE_NAME].fleetConfig;
    const res = await callUnAssignAPI(deliveryNo, fleetConfig);
    const comment = "Buddy has been un assigned."
    if(res.ok){}
    changeOrderStatus(orderId, deliveryNo);
    await addTimeLineEvent(agent, orderNo, orderId, timelineTypes.ORDER_STATUS, timelineNames.BUDDY_UNASSIGNED, comment);

  } catch (error) {
    console.log("unassign-order", error);
  }
}

export const cancelOrder = async (orderNo: string, orderId: string, reason: string) => {
  try {
    const agent = store.getState()[AUTH_STORE_NAME].loggedInAgent;
    const body = {
      "orderNo": orderNo,
      action: "CANCELLATION",
      orderId: orderId,
      reason: reason,
    }

    const comment = `Order has been cancelled by: ${agent.name} due to : ${reason}.`
    await callOmsOrderComplete(body);
    updateSelectedOrder('');
    await addTimeLineEvent(agent, orderNo, orderId, timelineTypes.ORDER_STATUS, timelineNames.CANCELLED, comment);

  } catch (error) {
    console.log("cancel-order", error);
  }
}

export const transferOrders = async (currentAgent: any, replacementAgent: any, orders: any, action: string) => {
  try {
    const agent = store.getState()[AUTH_STORE_NAME].loggedInAgent;
    const comment = `Order reassigned from ${currentAgent.name} to ${replacementAgent.name}.`

    orders = orders.map((order: Order) => {
      return {
      "id": order.id,
      "orderNo": order.orderNo,
      "orderType": order.orderType,
      "isBulk": order.orderInfo.isBulk,
      "isGrouped": order.orderInfo.isGrouped,
    }});

    await fetchOrderTransfer(currentAgent, replacementAgent, orders, action);
    await addTimeLineEvent(agent, orders[0].orderNo, orders[0].id, timelineTypes.AGENT, timelineNames.ORDER_TRANSFER, comment);

  } catch (error) {
    console.log("transfer-order", error);
  }
}

export const convertToBuy = async (orderId: string, orderNo: string) => {
  const agent = store.getState()[AUTH_STORE_NAME].loggedInAgent;
  const comment = "Change order type yo BUY."
  await changeOrderType(orderId, 'BUY');
  await addTimeLineEvent(agent, orderNo, orderId, timelineTypes.ORDER, timelineNames.ORDER_TYPE, comment);

} 

export const validateOrder = async(orderId: string, orderNo: string, notes: string[], orderValidation: any, notesUpdated: boolean, newNotes: string[], validationUpdated: boolean, fleetId: any, 
  userId: string, pickupId: string, deliveryId: string, isPickupValid: boolean, isDeliveryValid: boolean) => {
  const agent = store.getState()[AUTH_STORE_NAME].loggedInAgent;
  const objectValidated = (orderValidation.cart && orderValidation.pickup && orderValidation.delivery);
  try {
    if(orderValidation.pickup && !isPickupValid) {
      await validateAddress(userId, pickupId, true);
    } else if(!orderValidation.pickup && isPickupValid) {
      await validateAddress(userId, pickupId, false);
    }

    if(orderValidation.delivery && !isDeliveryValid) {
      await validateAddress(userId, deliveryId, true); 
    } else if(!orderValidation.delivery && isDeliveryValid) {
      await validateAddress(userId, deliveryId, false); 
    }
    await save(orderId, {
      notes: notes,
      orderValidation: orderValidation,
      'pickupAddress.isValid': orderValidation.pickup,
      'deliveryAddress.isValid': orderValidation.delivery,
    });
    if (fleetId) {
      if (notesUpdated) {
        const msgTitle = `You have a new note - ${orderNo}`;
        const msgBody = newNotes.join(". ");
        const comment = `New note has been sent: ${msgBody}.`
        buddiesNotifications(msgTitle, msgBody, fleetId);
        await addTimeLineEvent(agent, orderNo, orderId, timelineTypes.BUDDY, timelineNames.BUDDY_NOTIFICATION_NOTE, comment);
      }
      if (validationUpdated && objectValidated) {
        const msgTitle = `Validation - ${orderNo}`;
        const msgBody = "The order Cart, pickup address and delivery address are valid";
        const comment = "Order has been validated"
        buddiesNotifications(msgTitle, msgBody, fleetId);
        await addTimeLineEvent(agent, orderNo, orderId, timelineTypes.BUDDY, timelineNames.BUDDY_NOTIFICATION_VALIDATION, comment);
      }
    }
  } catch (error) {
    console.log("validate order-error: ", error);
  }
}

export const compensate = async(orderId: string, orderNo: string, compensation: any, user: any) => {
  try {
    const agent = store.getState()[AUTH_STORE_NAME].loggedInAgent;
    await save(orderId, {
      compensation: compensation.reason,
    });
    await createPromoCode(compensation.promoCode);
    const payload = {
      "msgTitle": `Hello ${user.name}, redeem your code` ,
      "msgBody": `Use the promocode ${compensation.promoCode.title} on your next order!`,
      "customers": [{
        id: user.id,
        pushTokens: user.settings.pushTokens
      }]
    }
    const comment = "Customer has been compensated"
    await sendNotifications(payload, "omsSendCustomerNotification");
    await addTimeLineEvent(agent, orderNo, orderId, timelineTypes.CUSTOMER, timelineNames.CUSTOMER_COMPENSATION, comment);
  } catch (error) {
    console.log("Compensation error: ", error)
  }
}

export const rescheduleCourierOrder = async(orderId: string, orderNo: string) => {
  try {
    const agent = store.getState()[AUTH_STORE_NAME].loggedInAgent;
    const fleetConfig = store.getState()[ORDER_STORE_NAME].fleetConfig;
    await reschedule(orderNo, fleetConfig);

    const comment = `Order has been rescheduled by: ${agent.name}.`
    await addTimeLineEvent(agent, orderNo, orderId, timelineTypes.ORDER_STATUS, timelineNames.RESCHEDULED, comment);
  } catch (error) {
    console.log("Reschedule error: ", error)
  }
}

export const changePaymentDetails = async (orderId: string, orderNo: string, paymentType: string, cashToCollect: number) => {
  const agent = store.getState()[AUTH_STORE_NAME].loggedInAgent;
  const fleetConfig = store.getState()[ORDER_STORE_NAME].fleetConfig;
  let type = paymentType === "CASH" ? 1 : 2;
  let cash = +cashToCollect;
  const res = await changePaymentInCourier(orderNo, type, cash, fleetConfig);
  if(res?.ok){
    const comment = `Payment type has been updated to ${paymentType}.`
    await savePaymentDetails(orderId, paymentType, cash);
    await addTimeLineEvent(agent, orderNo, orderId, timelineTypes.PAYMENT, timelineNames.PAYMENT_METHOD, comment);
  }
}

export const addDelayToOrder = async (orderId: string, deliveryAt: Date, time: number, delay: any) => {
  const deliveryDateAfterDelay = new Date(new Date(deliveryAt).getTime() + time * 60000);
  await save(orderId, { 
    deliveryAt: deliveryDateAfterDelay,
  }); 
  const manualDelayObj = {
    'etaMessage': delay.etaMessage,
    'etaMessageAr': delay.etaMessageAr,
    'reason': delay.reason,
  }
  await checkDelayNotificationValidity(orderId, manualDelayObj);
}

const buddiesNotifications = async(msgTitle: string, msgBody: string, fleetId: number) => {
  const agent = store.getState()[AUTH_STORE_NAME].loggedInAgent;
  const sentBy = {
    id: agent.id,
    name: agent.name,
    email: agent.email,
  };
  const buddy = await getBuddyDetails(fleetId);
    const payload = {
      "msgTitle": msgTitle,
      "msgBody": msgBody,
      "sentBy": sentBy,
      "buddies": [buddy]
    }
  sendNotifications(payload, "buddiesSendNotifications");
}

const addTimeLineEvent = async (agent: Agent, orderNo: string, orderId: string, type: string, name: string, comment: string) => {
  triggerPubSubEventCloudFunction({
    topicName: "TIMELINE_EVENT",
    data: {
      "orderId": orderId,
      "orderNo": orderNo,
      "createdAt": firebase.firestore.FieldValue.serverTimestamp(),
      type: type,
      name: name,
      "actorId": agent.id,
      "actorType": "AGENT",
      "agentId": agent.id,
      "agentName": agent.name,
      "referenceId": "",
      "referenceCollection": "",
      "comment": comment
    },
  })
}

export const uploadItemImage = async (orderId: string, file: any) => {
  return await uploadFileToStorage(orderId, file);
}
